import React from 'react';
export const FanvoiceItemDescription = ({ blockName, modifier, content }) => {
  const containerClassName = `${blockName}__description-container`;
  const className = `${blockName}__description`;
  return (
     <div className={ `${containerClassName} ${containerClassName}--${modifier}` }>
      <div className={ `${className} ${className}--${modifier}` }>
        { content }
      </div>
     </div>
  )
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceItemDescription.js